<template>
    <main class="blog-no-sidebar-wrapper">

        <!-- Header -->
        <theme-header />

        
        <!-- Breadcrumb -->
        <breadcrumb title="Grid no sidebar" subpage="blog" currentpage="grid no sidebar" />
        

        <!-- Blog no sidebar -->
        <blog-grid-no-sidebar />


        <!-- Footer -->
        <theme-footer />


        <!-- Back To Top -->
        <back-to-top btnText="Back to top" :showIcon="true" />

    </main>
</template>

<script>
import ThemeFooter from '../components/common/ThemeFooter.vue'
import ThemeHeader from '../components/common/ThemeHeader.vue'
import BackToTop from '../components/pieces/BackToTop.vue'
import breadcrumb from '../components/pieces/Breadcrumb.vue'
import BlogGridNoSidebar from '../components/sections/blogs/BlogGridNoSidebar.vue'

export default {
    name: 'BlogNoSidebar',
    components: {
        BackToTop,
        ThemeHeader,
        ThemeFooter,
        breadcrumb,
        BlogGridNoSidebar,
    },
    data() {
        return {

        }
    }
}
</script>
